import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class DiscountRuleService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAllRules(cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<any[]>('/api/DiscountRule', null, cancelToken);
    }
}

lazyRegister.service('DiscountRuleService', DiscountRuleService);
